import { render, staticRenderFns } from "./CustomizeMetalL.vue?vue&type=template&id=7fa3c3c1&scoped=true"
import script from "./CustomizeMetalL.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalL.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalL.vue?vue&type=style&index=0&id=7fa3c3c1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa3c3c1",
  null
  
)

export default component.exports